import loadable from '@loadable/component';

export const AsyncLogin = loadable(() => import('./Login'));
export const AsyncODashboardRedirect = loadable(
  () => import('./DashboardRedirect'),
);

export const AsyncOneTimeTokenLogin = loadable(
  () => import('pages/Login/LegacyOneTimeTokenLogin'),
);
